import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '480px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
};

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const usuarioActualNombre = () => {
    try {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (persona && persona.nombre) {
            return persona.nombre + (persona.apellido ? ' ' + persona.apellido : '');
        }
    } catch (e) {}
    return '';
};

/**
 * Modal de confirmación previo a publicar el programa (VEC-3336): muestra el resumen (nombre,
 * período, incluidos/excluidos, usuario responsable) y advierte —sin bloquear— si la fecha límite
 * de publicación configurada ya fue superada.
 *
 * Props:
 *   open        {boolean}
 *   programa    {object}   - { nombre, fecha_inicio, fecha_fin, fecha_limite_publicacion, resumen }
 *   onClose     {function}
 *   onConfirmar {function} - devuelve una Promise; el modal cierra solo si resuelve.
 */
const ProgramasPreventivosPublicarModal = (props) => {
    const intl = useIntl();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    if (!props.programa) return null;

    var programa = props.programa;
    var fechaLimiteSuperada = !!programa.fecha_limite_publicacion
        && programa.fecha_limite_publicacion < new Date().toISOString().slice(0, 10);

    var handleConfirmar = function() {
        if (loading) return;
        setLoading(true);
        props.onConfirmar()
            .then(function() {
                setLoading(false);
                props.onClose();
            })
            .catch(function() {
                setLoading(false);
            });
    };

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            className={classes.modal}
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={props.open}>
                <Box sx={modalStyle}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4 className="mb-0">
                            <i className="fa fa-bullhorn"></i>{' '}
                            <FormattedMessage id="programasPreventivosPublicar.titulo" defaultMessage="Publicar programa" />
                        </h4>
                        <button type="button" className="close" onClick={props.onClose} aria-label="close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div className="p-2 mb-3" style={{ background: '#f8f9fa', borderRadius: '4px', fontSize: '14px' }}>
                        <div className="mb-1"><strong>{programa.nombre}</strong></div>
                        <div className="text-muted mb-2">
                            {programa.fecha_inicio} — {programa.fecha_fin}
                        </div>
                        <div>
                            <FormattedMessage id="programasPreventivosDetalle.resumen_incluidas" defaultMessage="Incluidas:" />{' '}
                            <strong style={{ color: '#28a745' }}>{programa.resumen ? programa.resumen.incluidos : 0}</strong>
                            <span className="mx-2 text-muted">|</span>
                            <FormattedMessage id="programasPreventivosDetalle.resumen_excluidas" defaultMessage="Excluidas:" />{' '}
                            <strong style={{ color: '#dc3545' }}>{programa.resumen ? programa.resumen.excluidos : 0}</strong>
                        </div>
                        <div className="mt-2 text-muted">
                            <FormattedMessage
                                id="programasPreventivosPublicar.usuario_responsable"
                                defaultMessage="Responsable: {usuario}"
                                values={{ usuario: usuarioActualNombre() }}
                            />
                        </div>
                    </div>

                    {fechaLimiteSuperada && (
                        <div className="alert alert-warning" style={{ fontSize: '13px' }}>
                            <i className="fa fa-exclamation-triangle"></i>{' '}
                            <FormattedMessage
                                id="programasPreventivosPublicar.advertencia_fecha_limite"
                                defaultMessage="La fecha límite de publicación configurada ({fecha}) ya fue superada. Podés publicar igual."
                                values={{ fecha: programa.fecha_limite_publicacion }}
                            />
                        </div>
                    )}

                    <p className="text-muted" style={{ fontSize: '13px' }}>
                        <FormattedMessage
                            id="programasPreventivosPublicar.descripcion"
                            defaultMessage="El programa queda visible como Publicado para el equipo operativo. Vas a poder seguir haciendo ajustes después."
                        />
                    </p>

                    <div className="text-right mt-3">
                        <button type="button" className="btn btn-secondary mr-1" onClick={props.onClose} disabled={loading}>
                            <FormattedMessage id="programasPreventivosExclusion.btn_cancelar" defaultMessage="Cancelar" />
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleConfirmar} disabled={loading}>
                            <i className="fa fa-check-circle"></i>{' '}
                            <FormattedMessage id="programasPreventivosPublicar.btn_confirmar" defaultMessage="Confirmar publicación" />
                        </button>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ProgramasPreventivosPublicarModal;
